import { useTranslation } from 'react-i18next';

// zod messages carry an error-namespace key where one exists; anything else is
// already a literal string and is passed through untouched.
export const useValidationMessage = () => {
  const { t, i18n } = useTranslation();

  return (message?: string) => {
    if (!message) {
      return undefined;
    }

    const key = `error:${message}`;
    return i18n.exists(key) ? t(key) : message;
  };
};
